export interface NavChild {
  labelKey: string;
  path: string;
}

export interface NavItem {
  icon: string;
  labelKey: string;
  path?: string;
  children?: NavChild[];
}

export const NAV_ITEMS: readonly NavItem[] = [
  { icon: "$", labelKey: "cost.title", path: "/system/cloud-costs" },
  { icon: "D", labelKey: "nav.dashboard", path: "/" },
  { icon: "M", labelKey: "nav.metrics", path: "/metrics" },
  { icon: "I", labelKey: "nav.integrations", path: "/integrations" },
  {
    icon: "U",
    labelKey: "nav.users",
    children: [{ labelKey: "nav.users.all", path: "/users" }],
  },
  {
    icon: "C",
    labelKey: "nav.content",
    children: [
      { labelKey: "nav.content.conversations", path: "/content/conversations" },
      { labelKey: "nav.content.storage", path: "/content/storage" },
      {
        labelKey: "nav.content.storage_orphan_audit",
        path: "/content/storage/orphan-audit",
      },
      { labelKey: "nav.content.summary_jobs", path: "/content/summary-jobs" },
      { labelKey: "nav.content.deliveries", path: "/content/deliveries" },
    ],
  },
  {
    icon: "$",
    labelKey: "nav.revenue",
    children: [{ labelKey: "nav.revenue.billing", path: "/revenue/billing" }],
  },
  {
    icon: "G",
    labelKey: "nav.governance",
    children: [
      { labelKey: "nav.governance.relations", path: "/governance/relations" },
      { labelKey: "nav.governance.blocks", path: "/governance/blocks" },
      { labelKey: "nav.governance.agents", path: "/governance/agents" },
      {
        labelKey: "nav.governance.agent_reviews",
        path: "/governance/agent-reviews",
      },
      { labelKey: "nav.governance.grants", path: "/governance/grants" },
      { labelKey: "nav.governance.audit_log", path: "/governance/audit" },
      {
        labelKey: "nav.governance.space_reports",
        path: "/governance/space-reports",
      },
    ],
  },
  {
    icon: "N",
    labelKey: "nav.invites",
    children: [
      { labelKey: "nav.invites.applications", path: "/invites/applications" },
      { labelKey: "nav.invites.codes", path: "/invites/codes" },
    ],
  },
  {
    icon: "S",
    labelKey: "nav.system",
    children: [
      { labelKey: "nav.system.health", path: "/system/health" },
      {
        labelKey: "nav.system.communications",
        path: "/system/communications",
      },
      { labelKey: "nav.system.dlq", path: "/system/dlq" },
      { labelKey: "nav.system.crashes", path: "/system/crashes" },
      {
        labelKey: "nav.system.backend_api_coverage",
        path: "/system/backend-api-coverage",
      },
    ],
  },
];
